jQuery(function() {
  const mySwiper1 = new Swiper(".swiper1", {
    speed: 500,
    slidesPerView: 1,
    loopAdditionalSlides: 0,
    allowTouchMove: false,
    loop: true,
    spaceBetween: 30, // スライド間の余白（px）
    centeredSlides: true,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      // 横幅768px以上のとき～
      768: {
        slidesPerView: 3
      }
    },
    // ナビボタンが必要なら追加
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  if (window.matchMedia("(min-width: 769px)").matches) {
    /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
    mySwiper1.autoplay.stop(); //画面に現れるまでswiperを停止
    window.addEventListener("scroll", function() {
      // スライダーのコンテナ要素を取得
      const sliderContainer = document.querySelector(".swiper1");
      // スライダーのコンテナの位置情報を取得
      const rect = sliderContainer.getBoundingClientRect();
      // ウィンドウの高さを取得（クロスブラウザ対応）
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < windowHeight && rect.bottom >= 0) {
        // スライダーが画面内に入った場合、自動再生を有効にして開始
        mySwiper1.autoplay.start();
      } else {
        // 画面外に出た場合、自動再生を停止
        mySwiper1.autoplay.stop();
      }
    });
  } else {
    mySwiper1.autoplay.stop();
  }
  const mySwiper2 = new Swiper(".swiper2", {
    speed: 500,
    slidesPerView: 1,
    loopAdditionalSlides: 0,
    allowTouchMove: false,
    loop: true,
    spaceBetween: 30, // スライド間の余白（px）
    centeredSlides: true,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      // 横幅768px以上のとき～
      768: {
        slidesPerView: 3
      }
    },
    // ナビボタンが必要なら追加
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  if (window.matchMedia("(min-width: 769px)").matches) {
    mySwiper2.autoplay.stop(); //画面に現れるまでswiperを停止

    window.addEventListener("scroll", function() {
      // スライダーのコンテナ要素を取得
      const sliderContainer = document.querySelector(".swiper2");
      // スライダーのコンテナの位置情報を取得
      const rect = sliderContainer.getBoundingClientRect();
      // ウィンドウの高さを取得（クロスブラウザ対応）
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < windowHeight && rect.bottom >= 0) {
        // スライダーが画面内に入った場合、自動再生を有効にして開始
        mySwiper2.autoplay.start();
      } else {
        // 画面外に出た場合、自動再生を停止
        mySwiper2.autoplay.stop();
      }
    });
  } else {
    mySwiper2.autoplay.stop();
  }
});
